import { EstablishmentFieldRequestDetail } from "@/services/establishment-field-request.service"
import { AppColors } from "@/styles/colors"
import { Flex, Text } from "@chakra-ui/react"

interface Props {
  detail?: EstablishmentFieldRequestDetail | null
}

export const EstablishmentFieldRequestDetailDeleteMotive = ({ detail }: Props) => {
  // El motivo llega en dos partes: la descripción del motivo del catálogo que eligió el usuario
  // y la aclaración libre, que sólo traen los motivos que la admiten. En la app se puede llegar
  // a la aclaración sin pasar por la lista, así que puede venir aclaración sin categoría: ahí la
  // aclaración ocupa el renglón principal en vez de quedar escondida detrás de un guion.
  const motive = (detail?.motivoBaja ?? "").trim()
  const detailText = (detail?.motivoBajaDetalle ?? "").trim()
  const hasBoth = Boolean(motive) && Boolean(detailText)

  return (
    <Flex flexDir="column" gap="12px" paddingTop="10px">
      <Flex alignItems="center" gap="30px">
        <Text fontWeight={700}>Motivo de baja</Text>
      </Flex>

      <Flex
        flexDir="column"
        padding="12px"
        minHeight="120px"
        border={`1px solid ${AppColors.WHITE_BORDER_1}`}
        borderRadius="12px"
        gap="4px"
      >
        <Text fontSize="14px">{motive || detailText || "-"}</Text>

        {hasBoth && (
          <Text
            fontSize="14px"
            color={AppColors.GRAY_TEXT}
            data-testid="delete-motive-detail"
          >
            {detailText}
          </Text>
        )}
      </Flex>
    </Flex>
  )
}
